import { generateUtilityClass, generateUtilityClasses } from '@mui/core';
export function getUploadUtilityClass(slot) {
    return generateUtilityClass('FuiUpload', slot);
}
var uploadClasses = generateUtilityClasses('FuiUpload', [
    'root',
    'button',
    'drop',
    'cube',
    'uploadList',
    'uploadListItem',
    'uploadListItemSelected'
]);
export default uploadClasses;
